import React from 'react'
import ShortListCardListContainer from '../ShortListCardContainer';
import { useSelector } from 'react-redux';

function ShortListed({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <ShortListCardListContainer user={user} matches={user.shortlisted} title={title} />
    )
}

export default ShortListed